module.exports = __webpack_public_path__ + "img/wizard-02@2x.5323b2ef.png";